// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListHeader-root-IM0UN {
	background: var(--background-primary);
	color: var(--primary-foreground);
}

.ListHeader-container-dtImP {
	margin: 0 auto;
	padding: 0px;
	max-width: 100%;
	margin-bottom: 63px;
}

.ListHeader-commonListHeader-tEO12 {
	background: var(--background-primary);
	border-width: 0px 0px 1px 0px;
	border-color: var(--primary-border);
	border-radius: 0px;
	height: 63px;
	line-height: 63px;
	width: 100%;
	-webkit-box-shadow: none;
	        box-shadow: none;
	margin-bottom: 0px;
	z-index: 1001;
}

.ListHeader-brand-vgvFp {
	line-height: inherit;
	vertical-align: middle;
	text-decoration: none;
	height: 63px;
	float: none;
	padding: 0px 19px;
	color: var(--primary-foreground);
	font-size: 24px;
}

.ListHeader-brand-vgvFp:hover,
.ListHeader-brand-vgvFp:focus {
	text-decoration: none;
}

.ListHeader-brandImg-sKjfp {
	display: table-cell;
	padding-left: 12px;
	padding-right: 12px;
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
}

.ListHeader-brandImgToggle-qdsVr {
	padding-left: 12px;
	padding-right: 12px;
}

a:hover,
a:focus,
a:visited,
a:active {
	text-decoration: none !important;
}

.ListHeader-navBarToggle-L0SR4 {
	color: var(--primary-foreground);
	float: none;
	font-size: inherit;
	line-height: inherit;
	list-style: none;
	vertical-align: middle;
	border: 0px;
	border-radius: 0px;
	margin: 0px;
	padding: 0px 19px 0px 0px;
}

.ListHeader-brandBorder-VXR3z {
	border-right: none;
}

.ListHeader-navBarToggle-L0SR4:hover,
.ListHeader-navBarToggle-L0SR4:focus,
.ListHeader-navBarToggle-L0SR4:hover:focus {
	background: none;
}

.ListHeader-navBarToggleList-itYNU {
	float: left;
	padding: 0px;
	max-height: 63px;
}

.ListHeader-listBrand-GSG2T {
	padding: 0px 12px;
	vertical-align: top;
}

@media (max-width: 1200px) {
	.ListHeader-breakPoint-Z_D9b {
		display: none !important;
	}

	.ListHeader-commonListHeader-tEO12 {
		line-height: 86px;
	}

	.ListHeader-navBarToggleList-itYNU {
		max-height: inherit;
	}
}

@media screen and (max-width: 767px) {
	.ListHeader-commonListHeader-tEO12 {
		height: auto;
	}

	.ListHeader-container-dtImP {
		margin-bottom: 85px;
	}

}`, "",{"version":3,"sources":["webpack://./src/components/Header/List/ListHeader.css"],"names":[],"mappings":"AAAA;CACC,qCAAqC;CACrC,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;CACrC,6BAA6B;CAC7B,mCAAmC;CACnC,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,wBAAgB;SAAhB,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,gCAAgC;CAChC,eAAe;AAChB;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,mCAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;;;;CAIC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;CAChC,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,gBAAgB;CAChB,sBAAsB;CACtB,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;CAGC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,mBAAmB;CACpB;;AAED","sourcesContent":[".root {\n\tbackground: var(--background-primary);\n\tcolor: var(--primary-foreground);\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0px;\n\tmax-width: 100%;\n\tmargin-bottom: 63px;\n}\n\n.commonListHeader {\n\tbackground: var(--background-primary);\n\tborder-width: 0px 0px 1px 0px;\n\tborder-color: var(--primary-border);\n\tborder-radius: 0px;\n\theight: 63px;\n\tline-height: 63px;\n\twidth: 100%;\n\tbox-shadow: none;\n\tmargin-bottom: 0px;\n\tz-index: 1001;\n}\n\n.brand {\n\tline-height: inherit;\n\tvertical-align: middle;\n\ttext-decoration: none;\n\theight: 63px;\n\tfloat: none;\n\tpadding: 0px 19px;\n\tcolor: var(--primary-foreground);\n\tfont-size: 24px;\n}\n\n.brand:hover,\n.brand:focus {\n\ttext-decoration: none;\n}\n\n.brandImg {\n\tdisplay: table-cell;\n\tpadding-left: 12px;\n\tpadding-right: 12px;\n\tbackface-visibility: hidden;\n}\n\n.brandImgToggle {\n\tpadding-left: 12px;\n\tpadding-right: 12px;\n}\n\na:hover,\na:focus,\na:visited,\na:active {\n\ttext-decoration: none !important;\n}\n\n.navBarToggle {\n\tcolor: var(--primary-foreground);\n\tfloat: none;\n\tfont-size: inherit;\n\tline-height: inherit;\n\tlist-style: none;\n\tvertical-align: middle;\n\tborder: 0px;\n\tborder-radius: 0px;\n\tmargin: 0px;\n\tpadding: 0px 19px 0px 0px;\n}\n\n.brandBorder {\n\tborder-right: none;\n}\n\n.navBarToggle:hover,\n.navBarToggle:focus,\n.navBarToggle:hover:focus {\n\tbackground: none;\n}\n\n.navBarToggleList {\n\tfloat: left;\n\tpadding: 0px;\n\tmax-height: 63px;\n}\n\n.listBrand {\n\tpadding: 0px 12px;\n\tvertical-align: top;\n}\n\n@media (max-width: 1200px) {\n\t.breakPoint {\n\t\tdisplay: none !important;\n\t}\n\n\t.commonListHeader {\n\t\tline-height: 86px;\n\t}\n\n\t.navBarToggleList {\n\t\tmax-height: inherit;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.commonListHeader {\n\t\theight: auto;\n\t}\n\n\t.container {\n\t\tmargin-bottom: 85px;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ListHeader-root-IM0UN`,
	"container": `ListHeader-container-dtImP`,
	"commonListHeader": `ListHeader-commonListHeader-tEO12`,
	"brand": `ListHeader-brand-vgvFp`,
	"brandImg": `ListHeader-brandImg-sKjfp`,
	"brandImgToggle": `ListHeader-brandImgToggle-qdsVr`,
	"navBarToggle": `ListHeader-navBarToggle-L0SR4`,
	"brandBorder": `ListHeader-brandBorder-VXR3z`,
	"navBarToggleList": `ListHeader-navBarToggleList-itYNU`,
	"listBrand": `ListHeader-listBrand-GSG2T`,
	"breakPoint": `ListHeader-breakPoint-Z_D9b`
};
module.exports = ___CSS_LOADER_EXPORT___;
